import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceforcorporateeventsinpune() {



const cardData = {
  keyword: "Cab Service for Corporate Events in Pune ",

"headingDescription": "SRS Cab Service provides Cab Service for Corporate Events in Pune, offering professional, reliable, and comfortable transportation solutions for business conferences, meetings, seminars, and corporate gatherings. Our well-maintained fleet and experienced drivers ensure timely pickups, safe travel, and a hassle-free experience for employees and clients. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service makes corporate event transportation in Pune seamless, efficient, and stress-free.",
"topPlaces": [
  {
    "title": "Pune International Convention Center",
    "description": "A prime venue for corporate conferences and events. Companies rely on SRS Cab Service for transporting employees and guests to the Pune International Convention Center comfortably and on time."
  },
  {
    "title": "JW Marriott Pune",
    "description": "A popular hotel for corporate events and meetings. SRS Cab Service provides efficient cab services for corporate attendees to and from the hotel."
  },
  {
    "title": "Hyatt Pune",
    "description": "Corporate gatherings and business events frequently take place here. Travelers use SRS Cab Service for punctual and professional transportation."
  },
  {
    "title": "ICC Trade Tower",
    "description": "A commercial hub hosting corporate seminars and workshops. SRS Cab Service ensures smooth commuting for employees and event participants."
  },
  {
    "title": "Phoenix Market City Pune",
    "description": "Used for corporate launches and business events. SRS Cab Service provides reliable cab transport for corporate attendees."
  },
  {
    "title": "Renaissance Pune Hotel",
    "description": "A premium venue for corporate events and meetings. SRS Cab Service ensures timely and comfortable travel for all guests."
  },
  {
    "title": "The Westin Pune Koregaon Park",
    "description": "Frequent corporate events are held here. SRS Cab Service offers professional cab services for seamless transportation to the venue."
  },
  {
    "title": "Balewadi Stadium",
    "description": "Used for corporate team-building and large corporate gatherings. SRS Cab Service provides reliable transportation solutions."
  },
  {
    "title": "Swissotel Pune",
    "description": "A preferred location for business meetings and corporate events. SRS Cab Service ensures convenient and safe travel for attendees."
  },
  {
    "title": "PCMC Club and Conference Halls",
    "description": "Venues for corporate workshops and seminars. SRS Cab Service ensures timely and comfortable transportation for employees and clients."
  }
],



services: [
{
name: "Cab Service for Corporate Events in Pune",
description: "Cab service for corporate events in Pune offers reliable transportation for business gatherings and functions. Companies can book cabs for guests and staff. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with event cab services."
},
{
name: "Corporate Event Cab Service Pune",
description: "Corporate event cab service Pune provides organized transport for business events and conferences. Companies can manage guest travel efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with event cab services."
},
{
name: "Corporate Event Taxi Service Pune",
description: "Corporate event taxi service Pune offers convenient transportation for company events and meetings. Businesses can book taxis for guests and staff. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking for Corporate Events Pune",
description: "Cab booking for corporate events Pune provides easy reservation options for companies. Businesses can book cabs for event transport quickly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab booking services."
},
{
name: "Taxi Booking for Corporate Events Pune",
description: "Taxi booking for corporate events Pune offers convenient booking solutions for business events. Companies can reserve taxis for guest travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Corporate Event Transport Pune",
description: "Corporate event transport Pune provides reliable travel solutions for conferences and business events. Companies can arrange transport for large groups. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes are available. Travel easily with event transport services."
},
{
name: "Corporate Event Cab Hire Pune",
description: "Corporate event cab hire Pune offers flexible rental options for business travel. Companies can book cabs for events and meetings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Corporate Event Taxi Hire Pune",
description: "Corporate event taxi hire Pune provides convenient rental services for business events. Companies can book taxis for guest transport. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Corporate Event Travel Service Pune",
description: "Corporate event travel service Pune offers smooth transportation for business functions and corporate trips. Companies can manage travel efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel services."
},
{
name: "Corporate Event Cab Provider Pune",
description: "Corporate event cab provider Pune offers complete transport solutions for business events. Companies can outsource travel arrangements easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible service plans are available. Travel easily with cab provider services."
},
{
name: "Office Event Cab Service Pune",
description: "Office event cab service Pune provides reliable transport for company gatherings and celebrations. Businesses can arrange travel for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office event services."
},
{
name: "Business Event Cab Service Pune",
description: "Business event cab service Pune offers efficient travel for meetings and corporate functions. Companies can book cabs for clients and staff. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with business cab services."
},
{
name: "Corporate Event Car Rental Pune",
description: "Corporate event car rental Pune offers flexible vehicle options for business travel and events. Companies can book cars for short-term use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
}
],

tableData: [
["Cab Service for Corporate Events in Pune","Corporate Event Cab Service Pune"],
["Corporate Event Taxi Service Pune","Cab Booking for Corporate Events Pune"],
["Taxi Booking for Corporate Events Pune","Corporate Event Transport Pune"],
["Corporate Event Cab Hire Pune","Corporate Event Taxi Hire Pune"],
["Corporate Event Travel Service Pune","Corporate Event Cab Provider Pune"],
["Office Event Cab Service Pune","Business Event Cab Service Pune"],
["Corporate Event Car Rental Pune","Corporate Event Cab Service Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Cab Service for Corporate Events in Pune",
    WhyChoosedescription: "SRS Cab Service provides premium cab service for corporate events in Pune including conferences, seminars, office parties, exhibitions, and business gatherings with professional drivers and seamless coordination."
  },
  {
    WhyChooseheading: "Customized Event Transportation Solutions",
    WhyChoosedescription: "We offer fully customized transport plans for corporate events including guest pickups, VIP transfers, shuttle services, and group transportation tailored to your event requirements."
  },
  {
    WhyChooseheading: "Wide Fleet for All Event Needs",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, mini buses, and luxury vehicles for guests, employees, and executives."
  },
  {
    WhyChooseheading: "On-Time Pickup & Event Coordination",
    WhyChoosedescription: "We ensure punctual pickups and smooth coordination for all attendees, helping your corporate event run efficiently without any transportation delays."
  },
  {
    WhyChooseheading: "Professional Drivers & VIP Handling",
    WhyChoosedescription: "Our drivers are trained for corporate etiquette and VIP handling, ensuring comfortable, respectful, and professional service for all guests and executives."
  },
  {
    WhyChooseheading: "24/7 Service for Event Flexibility",
    WhyChoosedescription: "Our cab service is available 24/7 to manage early morning events, late-night functions, airport transfers, and multi-day corporate events."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Assurance",
    WhyChoosedescription: "All vehicles are equipped with GPS tracking for real-time monitoring, ensuring safety, route optimization, and smooth event logistics."
  },
  {
    WhyChooseheading: "Trusted Corporate Event Transport Partner",
    WhyChoosedescription: "SRS Cab Service is trusted by companies in Pune for reliable, affordable, and well-managed transportation for corporate events of all sizes."
  }
]
}

const faqData = [
  { 
    question: "Do you provide cab service for corporate events in Pune?", 
    answer: "Yes, SRS Cab Service offers professional cab service for corporate events in Pune including conferences, seminars, exhibitions, and office events with reliable transport solutions." 
  },
  { 
    question: "Can transport be customized for corporate events?", 
    answer: "Yes, we provide customized event transport solutions including VIP pickups, guest transfers, shuttle services, and dedicated vehicles based on event requirements." 
  },
  { 
    question: "What types of vehicles are available for events?", 
    answer: "We offer sedan cars, SUVs, Innova Crysta, Tempo Travellers, mini buses, and luxury vehicles suitable for different types of corporate events." 
  },
  { 
    question: "Do you provide airport transfers for event guests?", 
    answer: "Yes, we provide airport pickup and drop services for corporate guests attending events in Pune with timely and professional service." 
  },
  { 
    question: "Is service available for large corporate events?", 
    answer: "Yes, we provide transport solutions for both small gatherings and large-scale corporate events with flexible fleet options." 
  },
  { 
    question: "Are drivers trained for corporate service?", 
    answer: "Yes, our drivers are trained in professional behavior, VIP handling, and event coordination to ensure smooth service." 
  },
  { 
    question: "Is cab service available 24/7 for events?", 
    answer: "Yes, our service operates 24/7 to support events at any time including late-night and early morning schedules." 
  },
  { 
    question: "Do you provide shuttle service for events?", 
    answer: "Yes, we provide shuttle transport between hotels, venues, and offices for smooth movement of attendees." 
  },
  { 
    question: "Are services affordable for corporate events?", 
    answer: "Yes, we offer cost-effective corporate event transport solutions with transparent pricing and customized packages." 
  },
  { 
    question: "How can I book cab service for corporate events?", 
    answer: "You can book corporate event cab service by contacting us directly. We provide quick planning and execution support for your event." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Event Manager - Corporate Company",
    feedback:
      "We used SRS Cab Service for a corporate event in Pune and the experience was excellent. All vehicles were on time, drivers were professional, and the coordination was perfect.",
    rating: 5
  },
  {
    id: 2,
    name: "Admin Head - IT Firm",
    feedback:
      "Best cab service for corporate events in Pune. They handled guest transport and airport pickups smoothly. Very reliable and well-managed service.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Corporate Event Cab Service Pune",
  "description": "Reliable cab service for corporate events in Pune with SRS Cab. Book cabs and taxis for office events, business gatherings, and corporate travel. 24/7 service with Innova, Innova Crysta, Ertiga, Dzire, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/corporate-event-cab-service-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};





  return (
    <div>
      <Helmet>
  <title>Cab Service for Corporate Events in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service for corporate events in Pune with SRS Cab. Office and business event cabs available 24/7. Innova, Ertiga, sedan, SUV, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceforcorporateeventsinpune;